import { MockServiceStore } from "./MockServiceStore";

/**
 * StructureCast - Casting Day (a single day's production plan)
 */
export interface StructureCastCastingDay {
  id: string;
  castingGroupId: string;
  dayNumber: number;
  scheduledDate: string;
  actualCastDate: string;
  totalCubicYards: number;
  status: "planned" | "in_progress" | "completed";
  notes: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * Generate casting days for all 4 groups (Mid-State — Heritage Ranch WRRF).
 *   Group 1 (Deep Manholes):       2 days (completed)
 *   Group 2 (Standard Manholes):   3 days (in_progress — first 2 completed)
 *   Group 3 (Mid-Depth Manholes):  2 days (planned)
 *   Group 4 (Shallow Manholes):    2 days (planned)
 */
const generateCastingDays = (): StructureCastCastingDay[] => {
  const days: StructureCastCastingDay[] = [];

  const groupConfigs = [
    { id: "sc-cg-1", start: "2026-01-19", numDays: 2, status: "completed" as const },
    { id: "sc-cg-2", start: "2026-01-26", numDays: 3, status: "in_progress" as const },
    { id: "sc-cg-3", start: "2026-02-02", numDays: 2, status: "planned" as const },
    { id: "sc-cg-4", start: "2026-02-09", numDays: 2, status: "planned" as const },
  ];

  for (const config of groupConfigs) {
    const groupNum = config.id.split("-").pop();
    const startDate = new Date(config.start + "T00:00:00");
    const currentDate = new Date(startDate);
    let dayNum = 0;

    while (dayNum < config.numDays) {
      // Skip weekends
      if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
        dayNum++;
        const dateStr = currentDate.toISOString().split("T")[0];

        // CY varies between 1.5 and 4.4 per day (Mid-State capacity ~4.5 CY/day)
        const seed = (dayNum * 7 + parseInt(groupNum || "1", 10) * 13) % 17;
        const cy = +(1.5 + (seed / 17) * 2.9).toFixed(2);

        let dayStatus: StructureCastCastingDay["status"] = config.status;
        if (config.status === "in_progress" && dayNum <= 2) {
          dayStatus = "completed";
        }

        days.push({
          id: `sc-cd-${groupNum}-${dayNum}`,
          castingGroupId: config.id,
          dayNumber: dayNum,
          scheduledDate: dateStr,
          actualCastDate: dayStatus === "completed" ? dateStr : "",
          totalCubicYards: cy,
          status: dayStatus,
          notes: "",
          createdAt: "2025-11-15T00:00:00.000Z",
          updatedAt: "2026-01-19T00:00:00.000Z",
        });
      }

      currentDate.setDate(currentDate.getDate() + 1);
    }
  }

  return days;
};

export const mockStructureCastCastingDays: StructureCastCastingDay[] = generateCastingDays();

export const createMockStructureCastCastingDayStore = () =>
  new MockServiceStore<StructureCastCastingDay>({
    mockData: mockStructureCastCastingDays,
    idField: "id",
    simulateDelay: 200,
    persistKey: "preferred-structurecast-casting-days",
  });

export default mockStructureCastCastingDays;
